module.exports = __webpack_public_path__ + "h5/img/summer-title1-1.550889d6.png";